(function () {
  const fallbackLinks = [
    { href: '/pages/contact', label: 'Contact', match: 'contact', before: null }
  ];

  function textOf(node) {
    return (node && node.textContent ? node.textContent : '').trim().toLowerCase();
  }

  function hasLink(root, fallback) {
    return Array.from(root.querySelectorAll('a')).some((link) => {
      const text = textOf(link);
      return text === fallback.match || link.getAttribute('href') === fallback.href;
    });
  }

  function insertFallback(parent, item, fallback) {
    const children = Array.from(parent.children);
    const target = fallback.before ? children.find((child) => textOf(child).includes(fallback.before)) : null;
    if (target) {
      parent.insertBefore(item, target);
    } else {
      parent.appendChild(item);
    }
  }

  function addDesktopFallbackLinks() {
    document.querySelectorAll('#header-group .menu-list__list').forEach((list) => {
      fallbackLinks.forEach((fallback) => {
        if (hasLink(list, fallback)) return;

        const item = document.createElement('li');
        item.className = 'menu-list__list-item tl-nav-fallback-item';
        item.setAttribute('role', 'presentation');
        item.innerHTML = '<a href="' + fallback.href + '" class="menu-list__link tl-nav-fallback-link"><span class="menu-list__link-title">' + fallback.label + '</span></a>';
        insertFallback(list, item, fallback);
      });
    });
  }

  function addDrawerFallbackLinks() {
    document.querySelectorAll('#header-group .menu-drawer__menu.has-submenu').forEach((list) => {
      fallbackLinks.forEach((fallback) => {
        if (hasLink(list, fallback)) return;

        const item = document.createElement('li');
        item.className = 'menu-drawer__list-item tl-nav-fallback-item';
        item.innerHTML = '<a href="' + fallback.href + '" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset tl-nav-fallback-link"><span class="menu-drawer__menu-item-text wrap-text">' + fallback.label + '</span></a>';
        insertFallback(list, item, fallback);
      });
    });
  }

  function addFallbackLinks() {
    addDesktopFallbackLinks();
    addDrawerFallbackLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addFallbackLinks);
  } else {
    addFallbackLinks();
  }

  new MutationObserver(addFallbackLinks).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
